import React from 'react'

import { Box } from "@mui/material"
import { AppProviderChips } from "@components"


export default function providersColumn() {
	return {
		name: 'providersNames',
		label: 'Providers',
		options: {
			sortCompare: (order) => {
				return ({ data: data1 }, { data: data2 }) => {
					const value1 = data1[0]?.toString() || ""
					const value2 = data2[0]?.toString() || ""
					const isNumeric1 = !isNaN(value1)
					const isNumeric2 = !isNaN(value2)

					let comparison

					if (isNumeric1 && isNumeric2) {
						comparison = +value1 - +value2
					} else {
						comparison = value1.localeCompare(value2, undefined, { numeric: true, sensitivity: "base" })
					}
					return comparison * (order === 'asc' ? 1 : -1)
				}
			},
			customBodyRowRenderLite: value => (
				<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
					{value.length > 0
						? <AppProviderChips providers={value} sx={{ justifyContent: 'center' }}/>
						: "Any"
					}
				</Box>
			),
		}
	}
}
